import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useNursing } from "./NursingLayout";
import FacilitiesGrid from "@/components/FacilitiesGrid";

export default function Facilities() {
  const data = useNursing();
  const items = data?.facilities || [];
  return (
    <div data-testid="nursing-facilities">
      <PageHero eyebrow="Campus" title="World-class Facilities" accent="navy" />
      <PageBody>
        <FacilitiesGrid
          items={items}
          testidPrefix="nursing-facilities"
          accentChipClass="bg-slate-500/10 text-slate-700 ring-1 ring-slate-500/20"
        />
      </PageBody>
    </div>
  );
}
